import { fetchWithAuth } from '../../../common/utils/apiUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

class ZonaReservaCampesinaService {

    getMvtUrlTemplate() {
        return `${API_BASE_URL}/mvt/zona-reserva-campesina/{z}/{x}/{y}`;
    }

    /**
     * Get all Zonas de Reserva Campesina as GeoJSON
     * @returns {Promise} GeoJSON FeatureCollection
     */
    async getAllZonasReservaCampesinaGeoJson() {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/zona-reserva-campesina/geojson`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return { data };
        } catch (error) {
            console.error('Error fetching Zonas de Reserva Campesina GeoJSON:', error);
            throw error;
        }
    }

    /**
     * Get all Zonas de Reserva Campesina
     * @returns {Promise} List of Zonas de Reserva Campesina
     */
    async getAllZonasReservaCampesina() {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/zona-reserva-campesina`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching Zonas de Reserva Campesina:', error);
            throw error;
        }
    }

    /**
     * Get a Zona de Reserva Campesina by ID
     * @param {number} id - Zona de Reserva Campesina ID
     * @returns {Promise} Zona de Reserva Campesina
     */
    async getZonaReservaCampesinaById(id) {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/zona-reserva-campesina/${id}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching Zona de Reserva Campesina by ID:', error);
            throw error;
        }
    }

    /**
     * Get a Zona de Reserva Campesina by NOMBRE_ZON
     * @param {string} nombreZon - Zona name
     * @returns {Promise} Zona de Reserva Campesina
     */
    async getZonaReservaCampesinaByNombreZon(nombreZon) {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/zona-reserva-campesina/nombre-zon/${encodeURIComponent(nombreZon)}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching Zona de Reserva Campesina by NOMBRE_ZON:', error);
            throw error;
        }
    }

    /**
     * Upload GeoJSON file with Zonas de Reserva Campesina
     * @param {Object} geoJsonData - Complete GeoJSON object
     * @returns {Promise} Response with saved Zonas de Reserva Campesina
     */
    async uploadGeoJson(geoJsonData) {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/zona-reserva-campesina/upload`, {
                method: 'POST',
                body: JSON.stringify(geoJsonData)
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return { data };
        } catch (error) {
            console.error('Error uploading GeoJSON:', error);
            throw error;
        }
    }

    /**
     * Delete all Zonas de Reserva Campesina
     * @returns {Promise} Deletion confirmation
     */
    async deleteAllZonasReservaCampesina() {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/zona-reserva-campesina`, {
                method: 'DELETE'
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error deleting Zonas de Reserva Campesina:', error);
            throw error;
        }
    }

    /**
     * Convert Zonas de Reserva Campesina to GeoJSON format for map libraries
     * @param {Array} zonas - Array of Zonas from backend
     * @returns {Object} GeoJSON FeatureCollection
     */
    convertToGeoJSON(zonas) {
        return {
            type: 'FeatureCollection',
            features: zonas.map(zona => ({
                type: 'Feature',
                properties: {
                    id: zona.id,
                    objectId: zona.objectId,
                    nombreZon: zona.nombreZon
                },
                geometry: this.parseGeometry(zona.geometry)
            }))
        };
    }

    /**
     * Parse geometry string to GeoJSON
     * @param {string|Object} geometry - Geometry from backend
     * @returns {Object} Geometry in GeoJSON format
     */
    parseGeometry(geometry) {
        if (!geometry) {
            return null;
        }
        
        if (typeof geometry === 'string') {
            try {
                return JSON.parse(geometry);
            } catch (e) {
                console.error('Error parsing geometry:', e);
                return null;
            }
        }
        
        return geometry;
    }
}

export default new ZonaReservaCampesinaService();
